module.exports = __webpack_public_path__ + "img/70.913d65f1.jpg";